import type { api, Quote } from './api';
import { paraAltBirime } from './quote-pricing';
import { COLLECTION_UI as T } from './metin/collection';

export async function downloadQuoteProforma(quote: Quote,
  gateway: Pick<typeof api, 'publishQuote' | 'downloadQuotePdf'>,
  onQuote: (quote: Quote) => Promise<void>,
) {
  const status = quote.versions.find(entry => entry.versionNo === quote.currentVersionNo)?.status;
  if (!['DRAFT', 'PUBLISHED', 'ACCEPTED'].includes(status ?? '')) throw new Error(T.failed);
  let current = quote;
  if (status === 'DRAFT') {
    current = await gateway.publishQuote(quote.id, { versionNo: quote.currentVersionNo, expectedQuoteVersion: quote.version });
    await onQuote(current);
  }
  return gateway.downloadQuotePdf(current.id, current.currentVersionNo, current.code);
}

export async function recordQuoteReceipt(quote: Quote,
  input: { amount: string; reference: string; confirmed: boolean; method: string; key: string },
  gateway: Pick<typeof api, 'publishQuote' | 'acceptQuote' | 'quote' | 'createOrder' | 'recordPayment'>,
  onQuote: (quote: Quote) => Promise<void>,
) {
  const version = quote.versions.find(entry => entry.versionNo === quote.currentVersionNo);
  const amountMinor = paraAltBirime(input.amount);
  if (!input.confirmed || !['BANK_TRANSFER', 'CASH'].includes(input.method) || !['DRAFT', 'PUBLISHED', 'ACCEPTED'].includes(version?.status ?? '') || !Number.isSafeInteger(amountMinor) || amountMinor <= 0 || amountMinor > (version?.totalMinor ?? 0) || input.reference.trim().length < 3) throw new Error(T.invalidReceipt);
  let current = quote;
  if (version?.status === 'DRAFT') {
    current = await gateway.publishQuote(current.id, { versionNo: current.currentVersionNo, expectedQuoteVersion: current.version });
    await onQuote(current);
  }
  if (current.acceptedVersionNo !== current.currentVersionNo) {
    await gateway.acceptQuote(current.id, { versionNo: current.currentVersionNo, expectedQuoteVersion: current.version, idempotencyKey: `${input.key}-accept` });
    current = await gateway.quote(current.id);
    await onQuote(current);
  }
  const order = await gateway.createOrder({ quoteId: current.id, idempotencyKey: `${input.key}-order` });
  return gateway.recordPayment(order.order.id, { kind: amountMinor === version?.totalMinor ? 'FINAL' : 'PARTIAL', amountMinor, currencyCode: current.currencyCode, method: input.method, reference: input.reference.trim(), idempotencyKey: `${input.key}-receipt` });
}
